import React from 'react';

const SkeletonBlock = ({ className = '' }) => (
  <div className={`animate-pulse rounded-2xl bg-custom-surface-hover ${className}`.trim()} />
);

export const FullScreenLoader = ({ label = 'Cargando...' }) => (
  <div className="flex min-h-screen items-center justify-center bg-custom-bgapos px-6">
    <div className="w-full max-w-md rounded-3xl border border-custom-border bg-white/95 p-8 text-center shadow-[0_24px_80px_rgba(15,23,42,0.08)]">
      <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-custom-brand/10">
        <div className="h-7 w-7 animate-spin rounded-full border-2 border-custom-brand border-t-transparent" />
      </div>
      <p className="mt-5 text-lg font-semibold text-custom-text-primary">Box Digital</p>
      <p className="mt-2 text-sm text-custom-text-secondary">{label}</p>
    </div>
  </div>
);

export const RouteContentLoader = ({ label = 'Preparando vista...' }) => (
  <div className="space-y-6 p-1">
    <div>
      <SkeletonBlock className="h-9 w-64" />
      <SkeletonBlock className="mt-3 h-4 w-80 max-w-full" />
    </div>

    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4">
      {Array.from({ length: 4 }).map((_, index) => (
        <SkeletonBlock key={index} className="h-32" />
      ))}
    </div>

    <SkeletonBlock className="h-72" />

    <div className="flex items-center justify-center py-2 text-sm text-custom-text-secondary">
      <div className="mr-2 h-4 w-4 animate-spin rounded-full border-2 border-custom-brand border-t-transparent" />
      {label}
    </div>
  </div>
);

export const DashboardDataSkeleton = () => (
  <div className="space-y-6">
    <SkeletonBlock className="h-56 rounded-3xl" />

    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5">
      {Array.from({ length: 5 }).map((_, index) => (
        <SkeletonBlock key={index} className="h-28" />
      ))}
    </div>

    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5">
      {Array.from({ length: 5 }).map((_, index) => (
        <SkeletonBlock key={index} className="h-28" />
      ))}
    </div>

    <SkeletonBlock className="h-96" />
  </div>
);

export const TablePageSkeleton = () => (
  <div className="space-y-6">
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5">
      {Array.from({ length: 5 }).map((_, index) => (
        <SkeletonBlock key={index} className="h-24" />
      ))}
    </div>

    <SkeletonBlock className="h-28" />

    <div className="rounded-3xl border border-custom-border bg-white p-4 shadow-sm">
      <div className="space-y-3">
        {Array.from({ length: 8 }).map((_, index) => (
          <SkeletonBlock key={index} className="h-12 rounded-xl" />
        ))}
      </div>
    </div>
  </div>
);
